import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  cardContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#E2E8F0",
    marginBottom: 12,
    marginHorizontal: 4,
    overflow: "hidden",
    elevation: 2
  },
  cardHeader: {
    padding: 16
  },
  titleRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 12
  },
  cardTitle: {
    flex: 1,
    fontSize: 16,
    fontWeight: "600",
    color: "#1E293B",
    marginRight: 12
  },
  statusRow: {
    flexDirection: "row",
    alignItems: "center"
  },
  statusBadge: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12
  },
  statusBadgeText: {
    fontSize: 11,
    fontWeight: "700",
    textTransform: "uppercase"
  },
  arrowIcon: {
    marginLeft: 8
  },
  metaRow: {
    flexDirection: "row",
    justifyContent: "space-between"
  },
  metaColumn: {
    flex: 1,
    marginRight: 16
  },
  labelValueContainer: {
    marginBottom: 8
  },
  label: {
    fontSize: 11,
    color: "#64748B",
    fontWeight: "500",
    marginBottom: 2
  },
  valueRow: {
    flexDirection: "row",
    alignItems: "center"
  },
  value: {
    fontSize: 13,
    color: "#1E293B"
  },
  expandedSection: {
    borderTopWidth: 1,
    borderTopColor: "#F1F5F9",
    padding: 16,
    backgroundColor: "#F8FAFC"
  },
  descriptionBlock: {
    marginBottom: 20
  },
  descriptionHeading: {
    fontSize: 14,
    fontWeight: "600",
    color: "#475569",
    marginBottom: 8
  },
  descriptionText: {
    fontSize: 14,
    padding: 12,
    color: "#64748B",
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#E2E8F0"
  },
  attachmentHeading: {
    fontSize: 14,
    fontWeight: "600",
    color: "#475569",
    marginBottom: 12
  },
  attachmentBox: {
    width: 100,
    marginRight: 12,
    padding: 12,
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#E2E8F0",
    alignItems: "center"
  },
  attachmentLabel: {
    marginTop: 4,
    fontSize: 10,
    color: "#475569",
    textAlign: "center"
  },
  actionRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    borderTopWidth: 1,
    borderTopColor: "#E2E8F0",
    paddingTop: 16
  },
  editButton: {
    height: 50,
    paddingHorizontal: 20
  }
});
